export const underlinedStringRegex = /~([^~]*)~/g;

export const zipCodeRegex = /^[\w\s-]+$/;
